import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import {
  CLEAR_BILL_TRANSACTION_TYPE,
  FETCH_BILL_TRANSACTION_TYPE_FAILURE,
  FETCH_BILL_TRANSACTION_TYPE_LIST_FAILURE,
  FETCH_BILL_TRANSACTION_TYPE_LIST_PROGRESS,
  FETCH_BILL_TRANSACTION_TYPE_LIST_SUCCESS,
  FETCH_BILL_TRANSACTION_TYPE_PROGRESS,
  FETCH_BILL_TRANSACTION_TYPE_SUCCESS,
} from "./BillTransactionTypeActions";
import { initialBillTransactionTypeState } from "./BillTransactionType.types";
import { AccountingBillTransactionTypeActions } from ".";

export const AccountingBillTransactioTypeReducer = (
  state: IStoreState["accounting"]["billTransactionType"] = initialBillTransactionTypeState,
  action: AccountingBillTransactionTypeActions
) => {
  switch (action.type) {
    case FETCH_BILL_TRANSACTION_TYPE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_BILL_TRANSACTION_TYPE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }
    case FETCH_BILL_TRANSACTION_TYPE_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case FETCH_BILL_TRANSACTION_TYPE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.InProgress;
        draftState.list = [];
      });
      return newState;
    }

    case FETCH_BILL_TRANSACTION_TYPE_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }

    case FETCH_BILL_TRANSACTION_TYPE_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_BILL_TRANSACTION_TYPE: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.NotLoaded;
        draftState.data = initialBillTransactionTypeState.data;
        draftState.error = null;
      });
      return newState;
    }
    default:
      return state;
  }
};
